import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';

import {DirectorySyncManagedUserBanner} from './directory-sync-managed-user-banner';
import {UnlicensedUserBanner} from './unlicensed-user-banner';

type Props = {
    showLicenseBanner: boolean;
    showDsManagedUserBanner: boolean;
};

export function UserPageBanners(props: Props) {
    return (
        <div className='px-16 pt-16'>
            <StackLegacy spacing={4}>
                {props.showLicenseBanner && <UnlicensedUserBanner />}
                {props.showDsManagedUserBanner && <DirectorySyncManagedUserBanner />}
            </StackLegacy>
        </div>
    );
}
